import { GET_AFFILIATES } from '../types';

const initialState = {
  affiliates: null,
  loading: true,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_AFFILIATES:
      return {
        affiliates: payload,
        loading: false,
      };
    default:
      return state;
  }
}
